import axiosInstance from '../../../axiosInstance';

export const getIndustries = async () => {
  try {
    const response = await axiosInstance.get('/api/v1/lookups/industries');
    return response.data.items;
  } catch (error) {
    console.error('Error fetching industries:', error);
    return [];
  }
};
